type FieldError = { field: string; issue: string };

export type ErrorAction =
  | { type: "redirect_login" }
  | { type: "rate_limit"; userMessage: string }
  | { type: "role_changed"; userMessage: string }
  | { type: "last_superadmin"; userMessage: string }
  | { type: "not_found"; userMessage: string }
  | { type: "operator_not_found"; userMessage: string }
  | { type: "validation"; fields: FieldError[] }
  | { type: "server_error"; userMessage: string }
  | { type: "network_error"; userMessage: string }
  | { type: "generic"; userMessage: string };

export type NormalizedError = {
  code: string;
  message: string;
  details?: FieldError[];
  traceId?: string;
};

export function handleError(error: NormalizedError): ErrorAction {
  switch (error.code) {
    case "auth.unauthorized":
      return { type: "redirect_login" };

    case "admin.rate_limit_exceeded":
      return {
        type: "rate_limit",
        userMessage: "Превышен лимит запросов. Повторите позже.",
      };

    case "auth.forbidden_role":
      return {
        type: "role_changed",
        userMessage: "Ваши права изменились. Обновите страницу.",
      };

    case "admin.last_superadmin_protected":
      return {
        type: "last_superadmin",
        userMessage:
          "Нельзя изменить последнего суперадмина: удаление и смена роли запрещены.",
      };

    case "admin.user_not_found":
      return {
        type: "not_found",
        userMessage: "Пользователь не найден.",
      };

    case "admin.operator_not_found":
      return {
        type: "operator_not_found",
        userMessage: "Оператор не найден.",
      };

    case "admin.self_role_change":
      return {
        type: "generic",
        userMessage: "Нельзя изменить собственную роль.",
      };

    case "validation.invalid_field":
      return {
        type: "validation",
        fields: Array.isArray(error.details) ? error.details : [],
      };

    case "auth.invalid_token":
      return { type: "redirect_login" };

    case "auth.forbidden":
      return {
        type: "role_changed",
        userMessage: "Ваши права изменились. Обновите страницу.",
      };

    case "rate_limit.exceeded":
      return {
        type: "rate_limit",
        userMessage:
          "Слишком много запросов, повторите через несколько секунд.",
      };

    case "picks.admin_not_found":
      return { type: "not_found", userMessage: "Pick не найден." };

    case "request.invalid":
    case "picks.url_invalid":
    case "picks.media_invalid":
    case "picks.place_invalid":
    case "picks.content_invalid":
    case "picks.geo_invalid":
    case "picks.terms_invalid":
      return {
        type: "validation",
        fields: Array.isArray(error.details) ? error.details : [],
      };

    case "picks.write_unavailable":
      return {
        type: "server_error",
        userMessage:
          "Сохранение временно недоступно, данные формы сохранены, повторите.",
      };

    case "picks.partner_facts_stale":
      return {
        type: "generic",
        userMessage: "Публикация заблокирована: устарели факты партнёра.",
      };

    case "picks.geo_too_large":
      return {
        type: "generic",
        userMessage:
          "Геометрия слишком большая (максимум 512 КиБ). Упростите линию или уберите лишние точки.",
      };

    case "picks.revision_conflict":
      return { type: "generic", userMessage: "Изменено другим пользователем." };

    case "admin.already_taken_down":
    case "admin.already_restored":
    case "admin.override_active":
      return {
        type: "generic",
        userMessage: "Операция уже выполнена или недоступна.",
      };

    default:
      if (error.code.startsWith("picks.")) {
        return {
          type: "generic",
          userMessage: "Не удалось выполнить действие, повторите.",
        };
      }
      return {
        type: "generic",
        userMessage: error.message || "Что-то пошло не так. Повторите позже.",
      };
  }
}
